import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';
import config from '../../lib/config';
import styles from './styles';

const CircleButton = ({ onPress, iconName, disabled }: any) => {
  const style: any[] = [styles.viewMoreArrow];
  let color: any = config.theme.advert.headingTextColor;
  if (disabled) {
    style.push(styles.viewMoreArrowDisabled);
    color = styles.viewMoreArrowDisabled.borderColor;
  }
  return (
    <TouchableOpacity
      disabled={disabled}
      style={styles.submitArea}
      onPress={onPress}
    >
      <View style={style}>
        <Icon
          tvParallaxProperties={null}
          name={iconName || 'arrow-back'}
          size={26}
          color={color}
        />
      </View>
    </TouchableOpacity>
  );
};

export default CircleButton;
